import { Setting } from '../types/constant/PagesPropsType';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';
import { changeUnexpectedErrorMessage } from '../utils/formats';

export const useApplyCoupon = () => {
  /**
   * クーポン適用
   *
   * @param setting
   * @param coupon
   * @param subscription
   * @param success
   * @param failed
   * @param completion
   */
  const applyCoupon = (
    setting: Setting,
    subscription: SubscriptionApiType,
    coupon: string,
    success: () => void,
    failed: (response: string) => void,
    completion: () => void
  ) => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=updateSubscriptionCouponHistory`,
        { subscriptionContractId: subscription.subscriptionContractId, couponCode: coupon },
        { headers: { Authorization: setting.token } }
      )
      .then(() => {
        success();
      })
      .catch((e) => {
        console.log(e);
        const errorMessage = changeUnexpectedErrorMessage(e.response['data']);
        failed(errorMessage);
      })
      .finally(() => completion());
  };

  return {
    applyCoupon,
  };
};
